export const devNotes = [
  {
    date: "2026-10-20",
    title: "Administrative Taxonomic Revisions Implemented",
    text: "Implemented an administrative workflow for taxonomic revisions, including scientific and common name changes, genus transfers, species splits and mergers, impact previews, GitHub pull request integration, controlled application of approved changes, user notifications with affected-photo galleries, split reidentification, and recovery safeguards.",
  },
  {
    date: "2026-10-21",
    title: "Kingdom-Specific Lifeforms Implemented",
    text: "Renamed Form to Lifeform and implemented kingdom-specific selections with automatic taxonomic identification and manual kingdom selection when unknown. Added multiple selections, hierarchical life stages and plant structures, specialized subcategories, alphabetical ordering, and descriptive hover tooltips while preserving compatibility with existing observations.",
  },
  {
    date: "2026-09-25",
    title: "Community Rankings Implemented",
    text: "Implemented global and friends-only rankings based on species count, with photo totals, profile navigation, and friend-request controls to the community page as a fourth tab.",
  },

  {
    date: "2026-09-16",
    title: "Ecological Relationships",
    text: "It is now possible to edit species cards to link species through ecological relationships such as pollination, seed dispersal, predation, and more.",
  },

  {
    date: "2026-09-06",
    title: "Explore Taxonomy Improved",
    text: "Faster collection loading, shared-species indicators, and smoother photo navigation.",
  },

  {
    date: "2026-09-05",
    title: "Plant Species Descriptions",
    text: "Plant species now have a new field to edit: species descriptions! We can now, as a community, describe the species to assist with field identification. For some families and genera, I hard-coded traits that are in 100% of their species.",
  },
  {
    date: "2026-09-03",
    title: "Quiz Aesthetics Improved",
    text: "Overall aesthetic arrangement of quizzes has been improved.",
  },
  {
    date: "2026-08-24",
    title: "Explore Collection Switcher",
    text: "Switch between your collection and your friends’ collections directly from the taxonomy menu, with species totals and seamless navigation on desktop and mobile.",
  },

  {
    date: "2026-08-23",
    title: "Uploads now include a community recap",
    text: "The upload summary now highlights species new to your BioIndex and compares your photos with friends who have recorded the same species.",
  },
  {
    date: "2026-08-17",
    title: "Community feeds now load on demand",
    text: "Notifications and community activity now prioritize recent updates and automatically load additional history as you scroll.",
  },
  {
    date: "2026-08-17",
    title: "Profile loading optimized",
    text: "Improved Profile page efficiency so essential content becomes interactive sooner while heavier sections load progressively.",
  },
  {
    date: "2026-08-17",
    title: "Collection albums redesigned",
    text: "Redesigned the Collection viewer with polished desktop spreads, a dedicated mobile layout, clearer page navigation, smoother swiping, and improved photo viewing and editing.",
  },
  {
    date: "2026-08-17",
    title: "Upload workflow streamlined",
    text: "Simplified optional photo metadata and introduced a post-upload workspace for quickly organizing newly uploaded photos into one or more collections.",
  },
  {
    date: "2026-08-02",
    title: "Admin moderation expanded",
    text: "Added audited collection management and reversible account suspension and restoration controls.",
  },
  {
    date: "2026-08-01",
    title: "Search experience redesigned",
    text: "Redesigned the Search modal with improved navigation and new ways to browse by taxonomy, common name, location, recent uploads, and collections.",
  },
  {
    date: "2026-07-31",
    title: "Admin controls enabled",
    text: "Enabled dedicated admin controls to strengthen site security and moderation.",
  },
  {
    date: "2026-07-31",
    title: "User blocking implemented",
    text: "Implemented user blocking to hide unwanted content and prevent interactions between blocked accounts.",
  },
  {
    date: "2026-07-31",
    title: "Upload page refreshed",
    text: "Gave the Upload page a polished facelift across both desktop and mobile.",
  },
  {
    date: "2026-07-28",
    title: "Mobile taxonomy navigation redesigned",
    text: "Introduced custom BioIndex navigation icons and reorganized the mobile Explore Taxonomy interface with an edge-to-edge menu, streamlined taxonomy controls, and improved responsive card layouts.",
  },
  {
    date: "2026-07-23",
    title: "Genus card browser redesigned",
    text: "Redesigned the genus card browser with taxonomy filters, sorting, and a unified interface for viewing and selecting display cards.",
  },
  {
    date: "2026-07-20",
    title: "Community Feed refined",
    text: "Improved the feed layout, grouped related achievements into concise updates, and introduced kudos for celebrating friends’ activity.",
  },
  {
    date: "2026-07-18",
    title: "Community updates redesigned",
    text: "Daily photo activity is now grouped into concise, clickable updates with photo previews and species cards.",
  },
  {
    date: "2026-07-18",
    title: "Reply ratings added",
    text: "Forum comments and replies can now be rated as Helpful or Not Helpful.",
  },
  {
    date: "2026-07-16",
    title: "Community Feed goes live",
    text: "The Community Feed is now fully operational, providing a real-time activity stream of friends' accomplishments across BioIndex. New photo uploads, title unlocks, and genus card unlocks now appear automatically without requiring profile visits, complete with unread counters that reset after viewing.",
  },
  {
    date: "2026-07-16",
    title: "Achievement processing moved to Cloud Functions",
    text: "Achievement evaluation was migrated from client-side profile loading to dedicated Firebase Cloud Functions. BioIndex now processes uploads, title unlocks, genus card unlocks, notifications, and Community Feed updates automatically in the background, ensuring achievements are awarded consistently regardless of which page a user visits.",
  },
  {
    date: "2026-07-15",
    title: "Community page introduced",
    text: "Added the new Community page to BioIndex, serving as the platform's central space for discussion and notifications. Users can now create forum topics, participate in conversations, receive real-time notifications for friend requests, replies, title unlocks, and genus card unlocks, and respond to friend requests directly from the notification center. The Community Feed is currently in development and will be introduced in a future update.",
  },
  {
    date: "2026-07-13",
    title: "Improved title selection",
    text: "Enhanced the Select Title interface with a view toggle that lets users instantly switch between browsing all available titles and only those they have unlocked, making it much easier to find and select earned titles while preserving access to the complete collection.",
  },
  {
    date: "2026-07-13",
    title: "Collection management expanded",
    text: "Photos can now be added to collections without leaving the album by browsing the entire photo library using alphabetical, date, or location views, selecting multiple images at once, and adding them in a single action. The picker also clearly identifies photos already present in the collection to prevent duplicates.",
  },
  {
    date: "2026-07-13",
    title: "Photo notes and metadata enhanced",
    text: "Photos now support personal notes as part of their metadata. Notes can be added, edited, and saved alongside other observation details, and are displayed within the photo viewer.",
  },
  {
    date: "2026-07-13",
    title: "Species cards and metadata editor refined",
    text: "Metadata editing now behaves consistently across desktop and mobile, including improved month handling, proper inline editing states, automatic saving feedback, and cleaner layouts that prevent fields from overflowing their containers.",
  },
  {
    date: "2026-07-13",
    title: "Collection album editing polished",
    text: "Album titles and descriptions can now be edited directly on the decorative album page instead of through separate input panels, preserving the physical album aesthetic. Album management controls (Edit, Close, Reorder, Save, and Cancel) were redesigned to match the rest of BioIndex with cleaner proportions, improved positioning, and a more consistent visual style. Additional improvements included better fullscreen photo controls and background scroll locking while viewing or managing collections.",
  },
  {
    date: "2026-07-13",
    title: "Profile interface polished",
    text: "Refined several profile interface components for a cleaner and more consistent experience. Selected genus cards were redesigned to be more compact and visually refined, while the metadata summary cards used throughout the profile were updated to better accommodate long values without text bleeding or overflowing their containers. Numerous spacing and responsive layout improvements further unified the appearance of profile pages across desktop and mobile devices.",
  },
  {
    date: "2026-07-09",
    title: "Collection albums overhauled",
    text: "The viewer now features realistic album spreads, refined page aesthetics, intelligent photo layouts that adapt to portrait and landscape images, a thumbnail strip for quick navigation, improved drag-and-drop reordering with visual placement feedback, and synchronized page navigation. The entire experience was also redesigned for mobile with a dedicated single-page album layout while preserving the immersive animated page-turn experience on desktop.",
  },
  {
    date: "2026-07-05",
    title: "Social navigation improved",
    text: "Enhanced the social experience by allowing seamless navigation between friends directly from any profile, while preserving the visitor's own friend list, notifications, and activity state. Added contextual navigation controls for returning to the viewed profile or back to your own profile, improved loading behavior for friend statistics, highlighted the currently viewed profile within the Friends list, and refined taxonomic comparisons to show whether taxa are shared or unique between you and the visited user.",
  },
  {
    date: "2026-07-05",
    title: "Gallery experience redesigned",
    text: "Completely redesigned the profile gallery with museum-inspired framed highlights, customizable featured observations, new browsing modes by name, date, and location, photo carousels for multi-image species, improved navigation and selection workflow, interactive world map and calendar filters, refined glass effects, and decorative exhibit-style nameplates for a more polished presentation.",
  },
  {
    date: "2026-07-04",
    title: "Profile card redesigned",
    text: "Redesigned the profile header with a more prominent portrait-oriented profile photo, a dedicated collectible title display beneath the image, refined title selection styling, contextual hover explanations, improved visual hierarchy, and a cleaner, more polished layout across desktop and mobile.",
  },
  {
    date: "2026-07-02",
    title: "Location picker redesigned",
    text: "Redesigned the location picker with a cleaner interface, added support for quickly reusing recently mapped locations, introduced a satellite view toggle for easier habitat selection, and refined the overall layout and controls for a faster, more intuitive mapping experience.",
  },
  {
    date: "2026-06-30",
    title: "Public launch pages added",
    text: "Added a dedicated public BioIndex URL (www.bioindex.app) together with new Terms of Service, Privacy Policy, Copyright Notice, and Contact pages.",
  },
  {
    date: "2026-06-30",
    title: "Social hub redesigned",
    text: "Completely redesigned the Friends, Requests, and Discover sections with a unified card layout, larger profile photos, species counters, improved friend request controls, responsive mobile formatting, and a cleaner visual hierarchy for managing connections.",
  },
  {
    date: "2026-06-30",
    title: "Profile navigation cache refined",
    text: "Improved profile navigation so visiting another user’s page clears stale cached profile data before loading the new profile, preventing names, photos, highlights, and recent uploads from briefly showing the wrong user.",
  },

  {
    date: "2026-06-24",
    title: "Gemini identification tools added",
    text: "Added Gemini-powered identification suggestions to both the Upload and Rename workflows, allowing photos to be analyzed and matched to likely scientific and common names without leaving BioIndex. Suggestions now incorporate available date, location, and form information to improve relevance. An integrated iNaturalist search button was also added, making it easy to verify proposed identifications before saving changes.",
  },
  {
    date: "2026-06-17",
    title: "Upload validation strengthened",
    text: "Improved upload safeguards by requiring scientific names before photos can be submitted. Upload controls now remain disabled until all queued photos contain valid scientific names, preventing incomplete uploads and eliminating cases where users could receive a success message despite missing required species information.",
  },

  {
    date: "2026-06-12",
    title: "Quiz experience refined",
    text: "Refined the quiz interface with redesigned layouts, improved progress tracking, color-coded answer history, detailed end-of-quiz summaries, and expanded feedback. Photo-matching quizzes also received a dedicated layout that gives answer images more space while making progress and review information easier to follow.",
  },

  {
    date: "2026-06-10",
    title: "Amphibian taxonomy completed and names refreshed",
    text: "Added a complete amphibian taxonomy to BioIndex, covering all currently recognized amphibian species. Scientific and common names were also updated across the database.",
  },
  {
    date: "2026-06-08",
    title: "Taxonomic coverage modal refreshed",
    text: "Widened and restyled the taxonomic coverage modal with BioIndex colors, compact friend-coverage badges, improved row spacing, and the new scientific/common name sorting pill.",
  },
  {
    date: "2026-06-08",
    title: "Alphabetical exploration mode",
    text: "Added a new Alphabet mode to Explore Taxonomy, allowing observations to be browsed by letter rather than taxonomic rank, date, or location. Species can now be sorted by either scientific or common name, with dedicated alphabetical navigation, species-level cards, and thumbnail selectors for browsing multiple photos within each species.",
  },
  {
    date: "2026-06-08",
    title: "Mobile-friendly collection reordering",
    text: "Added a new tap-to-swap reordering mode for collections on mobile devices. Photos can now be selected, deselected, and swapped with confirmation prompts, providing an intuitive alternative to desktop drag-and-drop while preserving the existing collection ordering workflow.",
  },
  {
    date: "2026-06-08",
    title: "Unified species card styling",
    text: "Updated collection and taxonomy species cards to use the same distinctive BioIndex card shape, with square top edges and rounded bottom corners. This creates a more consistent browsing experience across collections, favorites, and taxonomy exploration.",
  },
  {
    date: "2026-06-08",
    title: "Profile photo upload safeguards",
    text: "Improved profile photo handling to ensure profile images come only from photos intentionally uploaded to BioIndex. Added validation to ignore external account images, simplified image selection behavior, and reinforced the optional, upload-based profile photo workflow.",
  },
  {
    date: "2026-06-06",
    title: "Date & Location Browsing Across Taxonomy",
    text: "Added global Date and Location browsing modes directly to the taxonomy stepper. Users can now switch from taxonomic navigation to chronological or geographic photo browsing from any taxonomy level, while preserving access to the standard kingdom–genus hierarchy and allowing a one-click return to taxonomy browsing.",
  },
  {
    date: "2026-06-06",
    title: "Shared Species Viewer",
    text: "Extracted the SpeciesPage viewer into a reusable SpeciesPhotoModal component. The same species card, photo carousel, editing tools, rename workflow, photo management features, and friend-photo browsing can now be launched from multiple areas of BioIndex without duplicating code, ensuring a consistent experience across taxonomy and photo browsing modes.",
  },
  {
    date: "2026-06-06",
    title: "Photo-First Taxonomy Exploration",
    text: "Introduced ExplorePhotoModes, allowing collections to be explored independently of taxonomy through Date and Location views. Photos can now be opened directly from these browsers using the full species viewer, including editing and management tools, without forcing users to navigate into taxonomic pages first.",
  },
  {
    date: "2026-06-06",
    title: "Multi-Photo Species Cards",
    text: "Upgraded SpeciesPage cards to support inline photo browsing. Species with multiple photos now display miniature thumbnail selectors, allowing users to preview different forms, life stages, or observations directly from the card before opening the full species viewer.",
  },
  {
    date: "2026-06-03",
    title: "New BioIndex branding and landing page redesign",
    text: "Introduced the first official BioIndex logo and refreshed the home screen with a dedicated banner header. Reorganized navigation elements, improved visual hierarchy, and updated the landing page to better reflect BioIndex’s identity as a biodiversity collection platform.",
  },
  {
    date: "2026-06-03",
    title: "Collection viewer redesigned with custom photo ordering",
    text: "Replaced the old single-photo collection browser with a four-column gallery view and Species-style photo cards. Added detailed photo inspection, fullscreen image viewing, collection-specific ordering, and an interactive drag-and-drop mode that allows photos to be rearranged visually within a collection while preserving custom layouts between sessions.",
  },
  {
    date: "2026-06-02",
    title: "Added map-based highlight browsing",
    text: "Introduced a new location browsing mode for Favorite Highlights. Photos can now be explored geographically using country and state/department filters alongside an interactive world map with mapped observation points. Added automatic handling of location naming variations, country highlighting, map zooming, and photo-level browsing so highlights can be selected directly from specific regions.",
  },

  {
    date: "2026-06-01",
    title: "Added calendar-based highlight browsing",
    text: "Introduced a new calendar browsing mode for Favorite Highlights. Photos can now be explored chronologically using year and month selectors, an interactive calendar, and previous/next date navigation. Date mode operates at the individual photo level, includes support for undated observations, and displays photo locations directly on each card.",
  },

  {
    date: "2026-05-31",
    title: "Favorites selector redesigned into a full-screen species browser",
    text: "Replaced the old dropdown-based favorite photo selector with a dedicated full-screen browsing experience inspired by the Species page. Added alphabetical navigation, scientific/common name sorting, four-column species card layout, photo variant previews with thumbnail selectors, left/right animated photo browsing, and visual selection highlighting. Introduced an attached confirmation panel with focused dimming of non-selected cards, plus a saving state indicator to provide clear feedback while favorite highlights are being updated.",
  },
  {
    date: "2026-05-29",
    title: "Unified photo-viewer redesign and palette standardization",
    text: "Refreshed the visual design of Recent Uploads, Favorite Photos, and Collection photo viewers to consistently use the BioIndex color palette. Restyled Date, Form, Variant, and Collection metadata bubbles, updated collection popovers, improved text visibility, and removed mobile-specific color inversions so metadata displays now appear consistently across desktop and mobile devices.",
  },
  {
    date: "2026-05-29",
    title: "Streamlined bulk metadata workflows during photo uploads",
    text: "Redesigned the Upload Photos experience by replacing the large 'Same Date', 'Same Location', and 'Same Collection' panels with a compact expandable 'Apply to all photos' interface. Added bulk Species assignment using the existing taxonomy autocomplete system, introduced icon-based navigation for shared metadata tools, and improved scientific-name handling by displaying species names in italics during both entry and selection.",
  },
  {
    date: "2026-05-29",
    title: "Map picker modernization and location-selection improvements",
    text: "Updated the Location Picker modal to match the BioIndex visual style, added current-location support using browser geolocation, implemented automatic reverse geocoding and nearest-place resolution, and removed unwanted Google map controls to create a cleaner and more focused mapping experience while laying groundwork for future custom map-view controls.",
  },
  {
    date: "2026-05-29",
    title: "Landing page visual refresh and BioIndex support integration",
    text: "Updated the home page to align with the official BioIndex color palette, including refreshed backgrounds, buttons, badges, icons, and typography styling for a more cohesive brand identity. Added a dedicated Ko-fi support button directly to the landing page, providing a prominent but unobtrusive way for users to support ongoing BioIndex development and future feature expansion.",
  },
  {
    date: "2026-05-29",
    title: "Permanent account deletion with archive cleanup",
    text: "Added a Delete Profile option to account settings, allowing users to permanently remove their BioIndex account and associated archive data. The deletion workflow now displays the profile name, user ID, and total number of photos scheduled for removal before confirmation, includes a dedicated progress overlay during deletion, removes species records, collections, friendships, friend requests, and uploaded photo files from Firebase Storage, and safely signs users out upon completion.",
  },
  {
    date: "2026-05-23",
    title: "Friend photo activity notifications and cross-device read tracking",
    text: "Added a social activity notification system for friend photo uploads. Friends modal now displays “+N new” badges when friends upload unseen photos, with centered scrollable activity panels listing recently added species/photos. Read status is now persisted through Firestore-backed `friendSeenActivity` tracking so notifications synchronize correctly across devices and browsers. Viewing and closing the activity panel automatically marks uploads as read.",
  },
  {
    date: "2026-05-23",
    title: "Cross-device notification tracking for social activity and updates",
    text: "Migrated developer note, wish list, and friend photo activity notifications from browser-local storage to persistent Firestore profile tracking. Notifications for new uploads and app updates now synchronize across devices and browsers, while friend activity badges automatically clear after visiting a friend's profile.",
  },
  {
    date: "2026-05-21",
    title: "Added unread counters for updates and wishes",
    text: "Implemented persistent unread badges for Developer Notes and Wishlist panels, allowing the home screen icons to display how many new entries have been added since the user last viewed each section.",
  },
  {
    date: "2026-05-21",
    title: "Added common-name taxonomy sorting",
    text: "Expanded ProfilePage taxonomic coverage browsing by adding optional species sorting based on common names, including reversible scientific/common-name display formatting and improved handling of unnamed species.",
  },
  {
    date: "2026-05-21",
    title: "Expanded rename workflows to photo level",
    text: "Upgraded SpeciesPage renaming tools to support photo-level reassignment within a species, allowing selected photos to be moved independently into a new or existing species entry.",
  },
  {
    date: "2026-05-21",
    title: "Restored add-photo upload controls",
    text: "Fixed a regression in SpeciesPage where entering add-photo mode hid the upload and cancel controls, restoring the ability to properly save or discard pending photo additions.",
  },

  {
    date: "2026-05-20",
    title: "Expanded reptile taxonomy coverage with common names",
    text: "Integrated the full Reptile Database taxonomy into BioIndex with standardized Squamata handling, automated family/genus hierarchy generation, and large-scale reconciliation of scientific names with English common names from existing BioIndex records and iNaturalist taxonomy data.",
  },
  {
    date: "2026-05-18",
    title: "Improved modal back-navigation behavior",
    text: "Added history-aware modal handling across ProfilePage and SpeciesPage so browser back gestures now close active overlays before leaving the page, creating smoother app-like navigation on desktop and mobile.",
  },
  {
    date: "2026-05-18",
    title: "Profile page aesthetic refinement and upload feed modernization",
    text: "Refined the ProfilePage interface with updated spacing, card styling, and section consistency across collections, social panels, genus displays, and recent uploads. Redesigned the Recent Uploads section into a compact scrollable activity feed with smaller image previews, upload timestamps, location display improvements, reduced visual density, and integration with the updated SpeciesPage photo viewing experience.",
  },
  {
    date: "2026-05-18",
    title: "Major SpeciesPage card and viewer redesign",
    text: "Completely revamped the SpeciesPage visual system by redesigning species cards, fullscreen viewers, metadata panels, navigation controls, and mobile layouts into a unified modern interface. Updated card spacing, rounded panel styling, metadata bubbles, image browsing behavior, fullscreen presentation, and responsive layouts to create a more immersive and visually consistent species exploration experience across desktop and mobile devices.",
  },
  {
    date: "2026-05-16",
    title: "Expanded geographic title tracking",
    text: "Added country- and region-based species tracking for profile titles, enabling geographic achievement unlocks tied to mapped observation metadata while preserving cached profile performance through cache versioning.",
  },
  {
    date: "2026-05-11",
    title: "Expanded mapped-location migration and editing workflows",
    text: "Refined the mapped-location system by improving click-based geographic resolution using nearby-place detection, reverse geocoding, political-region fallback handling, and nearest-place distance validation to generate more accurate location names from map selections.",
  },
  {
    date: "2026-05-10",
    title: "Refined profile refresh overlays",
    text: "Simplified ProfilePage loading overlays by removing unreliable percentage counters while preserving section-level loading spinners for cleaner and more consistent refresh behavior.",
  },
  {
    date: "2026-05-10",
    title: "Implemented spatial observation mapping system",
    text: "Replaced the old text-only location field with an interactive spatial mapping workflow using Google Maps integration. Added support for pinned observation locations, grouped mapped-location assignment, and automatic storage of geographic metadata including latitude, longitude, country, region, and locality data to support future geographic exploration and filtering tools.",
  },
  {
    date: "2026-05-01",
    title: "Expanded taxonomic coverage interactivity",
    text: "Improved the Taxonomic Coverage section by making coverage rows interactive and linking each taxonomic rank to a modal view of unlocked items. Added route resolution for kingdom, phylum, class, order, family, genus, and species entries so users can navigate directly from profile statistics into the corresponding taxonomy views.",
  },
  {
    date: "2026-05-01",
    title: "Implemented local profile caching with stale-section refresh",
    text: "Added local caching for profile data, taxonomic coverage, recent uploads, genus cards, collections, titles, and quiz species to make Profile pages appear faster on repeat visits. Introduced section-level refresh indicators and timestamp-based cache invalidation so stale profile, taxonomy, collection, and quiz data can be refreshed selectively after uploads, edits, deletions, or renames.",
  },
  {
    date: "2026-04-26",
    title: "Enhanced navigation and interactivity of genus cards",
    text: "Enabled direct navigation from genus cards to their corresponding taxonomy view by dynamically resolving full taxonomic paths. Improved interactivity by distinguishing between edit and navigation modes, ensuring intuitive behavior while maintaining editing functionality. Also refined visual elements such as badge positioning and text wrapping for improved clarity.",
  },
  {
    date: "2026-04-26",
    title: "Introduced customizable genus display cards on profile",
    text: "Added a new 'Unlocked Genus Cards' section to the profile, allowing users to showcase their favorite genera. Users can now select and update which genus cards are displayed, with cards dynamically unlocking based on uploaded species. This feature integrates taxonomy progression directly into the profile and reinforces collection growth through visual milestones.",
  },
  {
    date: "2026-04-26",
    title: "Improved mobile layout and responsiveness of profile sections",
    text: "Refined the mobile experience across the profile page, including restructuring action buttons for genus cards, introducing a two-column responsive grid, and scaling card proportions, typography, and spacing. These updates ensure consistent visual balance and usability across screen sizes without affecting desktop layouts.",
  },
  {
    date: "2026-04-21",
    title: "Enhanced friend request display with full profile context",
    text: "Upgraded the friend requests modal to display requester name, profile image, and selected title instead of raw user IDs. This improves clarity, aligns with other user-facing components, and creates a more cohesive social interaction experience across the platform.",
  },
  {
    date: "2026-04-21",
    title: "Implemented unfriend functionality with full relationship cleanup",
    text: "Added an unfriend action directly within friend cards, including confirmation and bidirectional removal of friendship data. The system also clears any existing friend requests between users, ensuring a consistent and clean state across social interactions.",
  },
  {
    date: "2026-04-21",
    title: "Refined Discover visibility rules for user metadata",
    text: "Updated Discover cards to conditionally hide species counts for non-friends while still displaying user titles. This preserves privacy expectations without reducing the richness of visible user identity.",
  },
  {
    date: "2026-04-21",
    title: "Redesigned profile title display with badge styling",
    text: "Transformed the title display into a styled badge element with improved visual hierarchy. The new design emphasizes progression and aligns with the platform’s gamified identity system.",
  },
  {
    date: "2026-04-21",
    title: "Introduced contextual hint system for profile titles",
    text: "Added an interactive tooltip next to the title badge explaining how titles are earned. This improves discoverability of progression mechanics without adding visual clutter.",
  },
  {
    date: "2026-04-21",
    title: "Replaced inline profile editing with modal-based workflow",
    text: "Moved profile editing (name, description, photo) into a dedicated modal interface. This prevents layout shifts, improves focus, and standardizes editing behavior across the app.",
  },
  {
    date: "2026-04-21",
    title: "Added explicit saving feedback to profile and title updates",
    text: "Implemented loading states for save actions, including disabled buttons and dynamic 'Saving...' labels. This provides clear user feedback during asynchronous operations and prevents duplicate submissions.",
  },
  {
    date: "2026-04-21",
    title: "Introduced onboarding description for new user profiles",
    text: "Added a default welcome message when profile descriptions are empty, guiding users to begin building their collection and personalize their profile.",
  },
  {
    date: "2026-04-21",
    title: "Implemented empty-state messaging across key profile sections",
    text: "Added clear, contextual messaging for empty Taxonomic Coverage and Recent Uploads panels. These states encourage user action while maintaining layout consistency.",
  },
  {
    date: "2026-04-21",
    title: "Overhauled quiz filter system for accuracy and clarity",
    text: "Restricted taxonomy filters to only include user-unlocked categories, removed hidden filtering thresholds, and visually disabled insufficient groups with explanatory labels. This ensures transparency and prevents invalid quiz configurations.",
  },
  {
    date: "2026-04-21",
    title: "Standardized navigation with centered action bar on Profile page",
    text: "Replaced the floating Home button with a unified, centered navigation bar including Home, Explore, Search, Upload, and Profile. Active state styling was introduced for improved orientation.",
  },
  {
    date: "2026-04-21",
    title: "Integrated Search modal into Profile navigation",
    text: "Added Search functionality directly into the Profile navigation bar, ensuring consistent access to global search across primary pages.",
  },
  {
    date: "2026-04-21",
    title: "Extended navigation pattern to Explore taxonomy pages",
    text: "Applied the same navigation system to Explore views with dynamic active state handling, reinforcing consistency across browsing and profile contexts.",
  },
  {
    date: "2026-04-21",
    title: "Resolved dual-header rendering inconsistency",
    text: "Fixed conflicting header layouts caused by separate loading and loaded render branches, ensuring consistent navigation behavior across all profile states.",
  },
  {
    date: "2026-04-21",
    title: "Improved Home page responsiveness for mobile devices",
    text: "Converted the Home layout to a full-screen mobile experience, removing card constraints and creating a more native app-like interface.",
  },
  {
    date: "2026-04-21",
    title: "Refined desktop Home layout for improved vertical balance",
    text: "Adjusted container width and spacing to produce a narrower, more vertically oriented card layout, improving visual rhythm and readability on larger screens.",
  },
  {
    date: "2026-04-20",
    title: "Introduced Recent Uploads panel with interactive preview",
    text: "Added a Recent Uploads card displaying the four most recent photos in a 2x2 grid. Each image retains full form metadata and integrates with the existing favorites modal, allowing users to click and view detailed information without duplicating viewer logic. The panel maintains layout consistency across profiles and reinforces visual engagement with the latest additions.",
  },
  {
    date: "2026-04-20",
    title:
      "Added interactive taxonomic coverage explorer with social comparison",
    text: "Transformed the taxonomic coverage panel into an interactive system where each level (kingdom to species) can be clicked to reveal unlocked taxa. Integrated friend-based comparison metrics, displaying the percentage of friends who share each taxon, introducing a social and rarity dimension to collections.",
  },
  {
    date: "2026-04-18",
    title: "Integrated quiz system directly into profile page",
    text: "Embedded the quiz interface within the Profile page, allowing users to configure and launch challenges without navigating away. This streamlines access to quizzes while maintaining full context of the user’s collection and filters.",
  },
  {
    date: "2026-04-18",
    title: "Enabled cross-profile and collection-based quiz generation",
    text: "Quizzes can now be generated from any visited profile, using that user’s species and photos instead of the viewer’s own. Added unified filtering to support both taxonomic levels and user-defined collections, allowing targeted quizzes from specific subsets of a collection.",
  },
  {
    date: "2026-04-17",
    title: "Implemented contextual hint system across form inputs",
    text: "Added per-field hint controls with toggleable tooltips to guide users during data entry. Hints are positioned using absolute overlays to avoid affecting layout flow, ensuring they remain informative without introducing spacing or alignment issues across the form.",
  },

  {
    date: "2026-04-17",
    title: "Refined interface aesthetics and visual consistency",
    text: "Standardized input styling across the upload interface by enforcing consistent heights, spacing, and typography. Improved overall visual balance through aligned controls, uniform component structure, and cleaner hierarchy, resulting in a more polished and cohesive user experience.",
  },

  {
    date: "2026-04-17",
    title: "Integrated plant taxonomy backbone with partial species coverage",
    text: "Established a functional plant taxonomy structure spanning major hierarchical ranks (orders, families, genera) to support classification and navigation. A complete species-level dataset is still lacking due to inconsistencies in source data, limiting full species coverage and reliable scientific-common name pairing.",
  },

  {
    date: "2026-04-13",
    title: "Enabled collection assignment during photo upload",
    text: "Users can now assign photos to collections directly within the Upload flow. The selector supports multi-select, creation of new collections, and persists selections to Firestore, ensuring full consistency with collection behavior across the app.",
  },
  {
    date: "2026-04-13",
    title: "Improved upload form layout and alignment",
    text: "Refined the Upload interface by aligning the variant and collections fields into a shared row and enforcing consistent input heights. This improves visual balance, reduces vertical space, and creates a more cohesive form layout.",
  },
  {
    date: "2026-04-13",
    title: "Fixed modal controls for shared photo viewing",
    text: "Resolved an issue where the EXIT button disappeared when viewing friend photos. The control bar now always renders, while edit, rename, and upload actions are strictly limited to the user's own photos, preserving full functionality without exposing unintended actions.",
  },
  {
    date: "2026-04-13",
    title: "Introduced custom photo collections",
    text: "Users can now create and manage custom collections by assigning photos to named groups. Collections are dynamically generated from photo metadata, enabling flexible organization and curated viewing of images across species.",
  },
  {
    date: "2026-04-06",
    title: "Integrated search into taxonomy navigation",
    text: "Search is now embedded directly within the Explore Taxonomy interface via a persistent top navigation bar. This replaces the standalone homepage search entry, allowing users to initiate searches seamlessly from any taxonomy level without interrupting navigation flow.",
  },
  {
    date: "2026-04-03",
    title: "Selective photo replacement during upload",
    text: "Added the ability to mark existing photos for deletion during upload. Users can now select one or more existing images, which are removed only after a successful upload, enabling safe and flexible replacement without risking data loss.",
  },
  {
    date: "2026-04-03",
    title: "Species rename now migrates and merges documents",
    text: "Updated renaming to move species documents so IDs always match scientific names. If the target already exists, forms are merged (with duplicates removed) and the old document is deleted, preventing duplicates and ensuring consistent uploads.",
  },
  {
    date: "2026-04-03",
    title: "Inline preview of existing species photos during upload",
    text: "Replaced the interruptive modal-based duplicate check with an inline preview of previously uploaded photos directly within the upload interface. Existing images are now displayed as a compact, clickable thumbnail card beneath each entry, with loading indicators and default photo highlighting. This improves flow by avoiding focus conflicts with the name suggester while providing immediate visual feedback and access to the full gallery on demand.",
  },
  {
    date: "2026-03-21",
    title: "Centralized social features within ProfilePage",
    text: "Redesigned ProfilePage as the main hub for all social interactions, including friends, requests, and user discovery. Added interactive modals for managing connections and navigating to other profiles, allowing removal of the global 'Add Friend' control from Home.",
  },
  {
    date: "2026-03-21",
    title: "Unlockable profile titles based on collection achievements",
    text: "Introduced a dynamic title system where users unlock profile titles based on their species photo collection metrics. Titles are evaluated from real data such as total species, photo count, locations, and taxonomic coverage, and updated automatically as the collection grows. A dedicated modal allows users to select from unlocked titles, while invalid or outdated selections are safely reset. This creates a progression system that rewards exploration and adds personality to each profile.",
  },
  {
    date: "2026-03-21",
    title: "Live social data with seamless profile navigation",
    text: "Integrated real-time listeners for friends and requests, enabling instant UI updates. Added clickable profile cards with species counts and default avatars, making ProfilePage a fully interactive social interface.",
  },
  {
    date: "2026-03-19",
    title: "Conditionally rendered photo view controls for clarity",
    text: "Updated SpeciesPage controls so that 'My Photos' and 'Friend Photos' toggles only appear when relevant. Buttons are hidden when no friend photos exist, and are completely disabled when viewing another user's collection, preventing duplicate or misleading views.",
  },
  {
    date: "2026-03-19",
    title: "Added friend photo viewing mode with owner attribution",
    text: "Implemented a 'Friend Photos' view within SpeciesPage, allowing users to browse photos contributed by friends for a given species. Each photo now includes owner metadata and displays the contributor’s name in the modal, providing clear attribution.",
  },
  {
    date: "2026-03-19",
    title: "Improved friend request lifecycle and UI synchronization",
    text: "Fixed an issue where accepted friend requests still appeared as pending for the sender. Ensured that accepted requests are properly deleted and that UI state prioritizes confirmed friendships over request status. This guarantees consistent rendering across both users after acceptance.",
  },
  {
    date: "2026-03-19",
    title: "Resolved Firestore permission issues for friend-based reads",
    text: "Updated Firestore rules to validate friendships via user subcollections instead of global documents. Introduced a rule-based exists() check against /users/{userId}/friends/{request.auth.uid}, and added explicit list permissions to support queries. This resolved 'Missing or insufficient permissions' errors when loading friend species data.",
  },
  {
    date: "2026-03-19",
    title: "Refactored friendships to user-scoped subcollections",
    text: "Replaced the global friendships collection with a user-centric structure using /users/{uid}/friends/{friendId}. Friendships are now written symmetrically to both users upon acceptance, eliminating the need for cross-collection lookups and simplifying security rules. This enables direct, permission-safe access to friend data and improves query performance.",
  },
  {
    date: "2026-03-18",
    title: "Improved taxonomy search formatting and readability",
    text: "Refined the visual presentation of search results across all taxonomy levels in the Search modal. Taxonomic paths are now properly capitalized and formatted using directional arrows instead of slashes, improving clarity and navigation flow. Genus names and scientific names in Common Name search are now displayed in italics to follow biological conventions. Subtitles were also visually softened to better emphasize primary labels.",
  },
  {
    date: "2026-03-18",
    title: "Search limited to user collection",
    text: "Updated the Search modal to only surface taxonomy levels that exist within the user’s own collection. Instead of traversing the full global taxonomy, the system now builds a filtered index based on the genera present in the user’s uploaded species. Higher taxonomic levels (family, order, class, kingdom) are dynamically reconstructed from those genera, ensuring that all search results lead to valid, populated pages.",
  },
  {
    date: "2026-03-18",
    title: "Preloaded species images for seamless navigation",
    text: "Added image preloading on modal open to ensure all species photos are cached upfront. This eliminates loading delays when navigating between images (next/prev), resulting in smoother and more responsive interaction for multi-photo species.",
  },
  {
    date: "2026-03-18",
    title: "Species renaming with taxonomy updates",
    text: "Added full species renaming support, including both scientific and common names. Updating the scientific name now automatically adjusts genus classification and reflects changes across the taxonomy structure.",
  },
  {
    date: "2026-03-17",
    title: "Full mammal taxonomy added",
    text: "Expanded and standardized the full mammal taxonomy across the app, including classes, orders, families, genera, and species, using the Mammal Diversity Database as the source.",
  },
  {
    date: "2026-03-17",
    title: "Smarter species name suggestions (3-character trigger)",
    text: "Refined the species name suggestion system in the Upload page to reduce lag during typing. The updateSuggestions function was modified to include a minimum character threshold so that suggestions only trigger when at least three characters are entered. Previously, speciesNames.filter(...) was executed on every keystroke, which caused noticeable slowdowns, especially on the first inputs. This change reduces unnecessary filtering operations while preserving the same behavior once enough input is provided.",
  },
  {
    date: "2026-03-16",
    title: "Empty collection message in Explore",
    text: "Added an empty-state message to the Explore page for users who have not yet uploaded any species. Instead of showing a blank screen when no kingdoms are available, the interface now explains that the collection is empty and invites the user to upload their first photos. A direct Upload Photos button was also added to guide new users toward starting their Bioindex.",
  },
  {
    date: "2026-03-16",
    title: "Home navigation added to Friends page",
    text: "Added the standard Home navigation button to the Friends page so that it matches the navigation structure used throughout the rest of the site. The button is placed in the same sticky header position used on other pages, allowing users to quickly return to the main page while browsing friends, requests, and suggested users.",
  },
  {
    date: "2026-03-16",
    title: "Safer photo uploads and clearer feedback",
    text: "Improved the photo upload system across both the main Upload page and the Species page. Uploads are now processed sequentially and each photo tracks its own status (pending, uploading, success, or error), allowing users to clearly see which images completed successfully and which failed. A maximum limit of 10 photos per upload batch was also introduced to prevent unstable interactions with Firebase. If users attempt to add more than 10 images at once, the interface now explains the limit instead of silently rejecting files. These changes make the upload process more transparent, reliable, and easier to understand when something goes wrong.",
  },
  {
    date: "2026-03-16",
    title: "Expanded taxonomy coverage",
    text: "Greatly expanded the taxonomy file to include a far more complete set of genera and families. The purpose of this change is to allow species photos uploaded by other users to remain fully compatible with the platform even when those species are not present in the developer's personal collection. With the expanded taxonomy, the system can now recognize and place species uploaded by other collectors without requiring the developer to already have that species recorded.",
  },
  {
    date: "2026-03-16",
    title: "BirdLife taxonomy integration for Aves",
    text: "Adopted the official BirdLife International taxonomy from https://datazone.birdlife.org to populate the full list of bird species. This dataset now provides the authoritative scientific names and common names for all Aves in the system. As a result, SpeciesNames.js has been strengthened so that bird common names are now sourced directly from BirdLife, replacing previously manual entries and ensuring consistent naming across the platform.",
  },
  {
    date: "2026-03-16",
    title: "Taxonomy loading cards",
    text: "Replaced the previous taxonomy loading behavior that briefly displayed all cards before filtering. Each taxonomy level now renders a single centered loading card while species counts are fetched from Firestore. Once counts resolve, only taxonomy levels containing species are rendered. This prevents visual flicker, avoids cards appearing and disappearing, and keeps navigation smoother when exploring both the developer's collection and other users' collections.",
  },
  {
    date: "2026-03-16",
    title: "Taxonomy stepper navigation fix",
    text: "Fixed the Kingdom step in the TaxonomyStepper incorrectly linking to the homepage.",
  },
  {
    date: "2026-03-16",
    title: "Species name autocomplete",
    text: "Added an autocomplete utility to the UploadPage that suggests species while typing in either the scientific name or common name fields. Selecting a suggestion automatically fills both fields, reducing typing errors and speeding up uploads. The dropdown currently draws from a speciesNames library generated from the developer's existing Firestore species collection, serving as the initial dataset for recommendations.",
  },
  {
    date: "2026-03-15",
    title: "Existing species detection restored",
    text: "Fixed the UploadPage species check that detects previously uploaded photos. Updated the lookup to match the stored document format, restoring the modal that displays existing photos and their metadata when a previously uploaded species is entered.",
  },
  {
    date: "2026-03-15",
    title: "Homepage layout refinement",
    text: "Adjusted the proportions of the BioIndex main card to improve balance and visual density. Reduced vertical padding and slightly decreased button height to create a more compact layout, while preserving readability and clickability.",
  },
  {
    date: "2026-03-15",
    title: "Developer notes",
    text: "Created a subtle developer notes icon that when clicked provides a list of recent additions or bug fixes by the developer.",
  },
  {
    date: "2026-03-15",
    title: "Automatic profile creation",
    text: "First-time Google login now creates a Firestore profile document with name extracted from the gmail account, allowing for the account to be found in the backend.",
  },
  {
    date: "2026-03-14",
    title: "Navigation context fix",
    text: "Fixed TaxonomyStepper so navigation inside /explore/:uid keeps the correct user context.",
  },
];
